import { render } from "./DetailedProjectCollaterals.vue?vue&type=template&id=d0515680&scoped=true"
import script from "./DetailedProjectCollaterals.vue?vue&type=script&lang=js"
export * from "./DetailedProjectCollaterals.vue?vue&type=script&lang=js"

import "./DetailedProjectCollaterals.vue?vue&type=style&index=0&id=d0515680&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0515680"]])

export default __exports__